import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from 'material-ui';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

import PersonIcon from 'material-ui/svg-icons/social/person';

const styles = {
    chip: {
        margin: 4,
    },
};


const TrainerSegmentAdmin = ({trainers, addAction, deleteAction}) => {

    const iconProps = {
        color: 'rgba(117, 117, 117 ,0.7)',
    };

    return (
        <Card className="cent-card ">
            <CardHeader
                title="Trainers"
                subtitle="manage trainers"
                avatar={<PersonIcon {...iconProps}/>}
            />
            <CardText className="cent-card-text">
                {trainers.map(({ name, id }) => (
                    <Chip
                        key={id}
                        style={styles.chip}
                        onRequestDelete={() => deleteAction(Number(id))}
                    >{name}
                    </Chip>
                ))}
            </CardText>
            <CardActions>
                <FlatButton
                    label="Add"
                    onTouchTap={addAction}
                />
            </CardActions>
        </Card>
    );
};

TrainerSegmentAdmin.propTypes = {
    trainers: PropTypes.arrayOf(PropTypes.object)
};

export default TrainerSegmentAdmin;
